import {FC} from 'react';
import {Popup} from 'semantic-ui-react';

import {BaseActionButton} from './BaseActionButton';
import NodeProperties from '../NodeProperties';
import {ctrlNodeWidth} from '../../../cablingMapEditor/const';

class Properties extends BaseActionButton {
  icon = 'wrench';
  tooltip = 'Manage properties of selected node(s)';

  disabled = () => {
    const {selection} = this.rackEditorStore;
    return selection.nothingSelected;
  };

  onClick = () => {
    this.hidePopups(true, true);
    this.rackEditorStore.rackStore.toggleOptions();
  };

  render: FC = () => {
    const {rackStore: {optionsAreShown}, selection: {nothingSelected}, selectedNodes} = this.rackEditorStore;
    return (
      <Popup
        {...this.popupCommonProps()}
        open={optionsAreShown && !nothingSelected}
        style={{width: ctrlNodeWidth}}
      >
        <NodeProperties nodes={selectedNodes} />
      </Popup>
    );
  };
}

export {Properties};
